<template>
    <Dialog
        v-model:visible="visible"
        :style="{ width: '400px' }"
        header="Link Details"
        :modal="true"
        :dismissableMask="true"
        @hide="$emit('hide-dialog', true)"
    >
        <div class="surface-section">
            <ul class="list-none p-0 m-0 surface-container">
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 font-medium">Step From</div>
                    <div
                        class="text-900 md:flex-order-0 flex-order-1"
                    >{{ props.link?.step_from?.label??stepStore.getStepLabelById(props.link.step_from)}}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 font-medium">Step To</div>
                    <div
                        class="text-900 md:flex-order-0 flex-order-1"
                    >{{ props.link?.step_to?.label??stepStore.getStepLabelById(props.link.step_to)}}</div>
                </li>
                <li v-if="link.formula_id" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 font-medium">Formula</div>
                    <div
                        class="text-900 md:flex-order-0 flex-order-1"
                    >{{ props.link?.formula?.code}}</div>
                </li>
                <li v-if="link.attribute_code" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 font-medium">Attribute</div>
                    <div
                        class="text-900 md:flex-order-0 flex-order-1"
                    >{{ props.link?.attribute_code}}</div>
                </li>
                <li v-if="link.operator" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 font-medium">Operator</div>
                    <div class="text-900 md:flex-order-0 flex-order-1">{{ props.link?.operator}}</div>
                </li>
                <li v-if="link.value" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 font-medium">Value</div>
                    <div class="text-900 md:flex-order-0 flex-order-1">{{ props.link?.value}}</div>
                </li>
            </ul>
        </div>
    </Dialog>
</template>

<script setup>
import { ref, defineProps, inject } from 'vue';

const props = defineProps({
	link: {
		type: Object,
	},
});

const stepStore = inject('stepStore');

const visible = ref(true);
</script>